import { motion } from 'framer-motion';

const ProfileSection = () => {
  return (
    <section className="py-20 bg-gradient-to-b from-gray-50 to-white">
      <div className="max-w-7xl mx-auto px-6">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center mb-16"
        >
          <div className="inline-block mb-6 px-6 py-2 border border-red/20 bg-red/5 rounded-full">
            <span className="text-red text-sm font-medium">PROFILE</span>
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            代表プロフィール
          </h2>
          <p className="text-xl text-gray-600">
            勝つ経営を実現する
          </p>
        </motion.div>

        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Left: Image */}
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ delay: 0.2 }}
          >
            <div className="relative rounded-3xl overflow-hidden shadow-2xl">
              <div className="w-full" style={{ aspectRatio: '800/1000' }}>
                <img
                  src="https://static.readdy.ai/image/d7a11723d8aa082f15ef10141684e0c1/c3bdfac7e5be97a6aac664b75c2d9360.png"
                  alt="赤石崇士"
                  className="w-full h-full object-cover object-top"
                />
              </div>
            </div>
          </motion.div>

          {/* Right: Profile Info */}
          <motion.div
            initial={{ opacity: 0, x: 30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ delay: 0.3 }}
          >
            <div className="bg-gradient-to-br from-red/5 to-red-light/5 rounded-3xl p-10 border border-red/10 mb-8">
              <h3 className="text-4xl font-bold text-red mb-4">
                赤石 崇士
              </h3>
              <p className="text-xl text-gray-700 mb-6">
                公認会計士・税理士・事業コンストラクター
              </p>
              <div className="space-y-4">
                <div className="flex items-center gap-4">
                  <div className="w-12 h-12 bg-red/10 rounded-full flex items-center justify-center flex-shrink-0">
                    <i className="ri-award-line text-red text-xl"></i>
                  </div>
                  <div>
                    <div className="font-bold text-gray-900">資格</div>
                    <div className="text-gray-600 text-sm">
                      公認会計士・税理士・事業コンストラクター
                    </div>
                  </div>
                </div>
                <div className="flex items-center gap-4">
                  <div className="w-12 h-12 bg-red/10 rounded-full flex items-center justify-center flex-shrink-0">
                    <i className="ri-briefcase-line text-red text-xl"></i>
                  </div>
                  <div>
                    <div className="font-bold text-gray-900">事務所</div>
                    <div className="text-gray-600 text-sm">
                      赤石会計事務所 代表
                    </div>
                  </div>
                </div>
                <div className="flex items-center gap-4">
                  <div className="w-12 h-12 bg-red/10 rounded-full flex items-center justify-center flex-shrink-0">
                    <i className="ri-map-pin-line text-red text-xl"></i>
                  </div>
                  <div>
                    <div className="font-bold text-gray-900">出身</div>
                    <div className="text-gray-600 text-sm">
                      京都府京都市
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="space-y-4 text-gray-700 leading-relaxed mb-8">
              <p>
                京都で生まれ育ち、大阪大学経済学部を卒業後、東証1部上場会社の印刷会社に入社。
                営業部と経理部での実務経験を通じて、企業経営の現場を深く理解しました。
              </p>
              <p>
                2004年に公認会計士2次試験に合格後、監査法人で上場企業等の監査、税務申告業務、
                不正調査など多様な業務に従事。2009年9月に赤石会計事務所を開業し、現在に至ります。
              </p>
              <p>
                「勝つ経営」を実現するために、単なる税務申告代行ではなく、
                経営者の良きパートナーとして、実践的なアドバイスで事業の成長をサポートすることを使命としています。
              </p>
            </div>

            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
            >
              <a
                href="/profile"
                className="inline-flex items-center gap-2 bg-red text-white px-8 py-4 rounded-full text-[15px] font-medium hover:bg-red-dark transition-all hover:scale-105 whitespace-nowrap cursor-pointer shadow-lg"
              >
                <span>詳しいプロフィールを見る</span>
                <i className="ri-arrow-right-line"></i>
              </a>
            </motion.div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default ProfileSection;
